import clsx from 'clsx';
import ExpandableSection from '../expandable-section/expandable-section';
import { EvaluationConversationProps } from './types';
import { isConnectedAgent } from '../../../lib/edge-functions';

function EvaluationConversation({
  title,
  simulation,
  forceExpanded = false,
}: EvaluationConversationProps) {
  const isImportedAgent = isConnectedAgent(simulation.agent);
  return (
    <div data-onboarding="evaluation-conversation">
      <ExpandableSection
        title={title}
        defaultExpanded={forceExpanded}
        forceExpanded={forceExpanded}
      >
        <div className="flex flex-col gap-2">
          {simulation.messages.map((message, index) => (
            <div
              key={index}
              className={clsx(
                'flex',
                message.role === 'user' ? 'justify-end' : 'justify-start',
              )}
            >
              <div
                className={clsx(
                  'max-w-[80%] rounded-lg p-2',
                  message.role === 'user'
                    ? 'bg-prompt-safecomoutrageous-orange text-white'
                    : 'bg-prompt-safecomgallery',
                )}
              >
                {isImportedAgent &&
                  index === 0 &&
                  message.role === 'assistant' && (
                    <span className="mb-1 block text-xs text-prompt-safecomabbey">
                      Opening message · not from your agent
                    </span>
                  )}
                {message.content}
              </div>
            </div>
          ))}
        </div>
      </ExpandableSection>
    </div>
  );
}

export default EvaluationConversation;
